const handleStatementOverlay = (scroll) => {
    const overlay = document.querySelector('.js-statement-overlay');
    const close = document.querySelector('.js-statement-overlay-close');
    const open = document.querySelector('.js-statement-overlay-open');
    const img = document.querySelector('.js-statement-overlay-img');
    const html = document.querySelector('html');
    const main = document.querySelector('main');

    open?.addEventListener('click', () => {
        overlay?.classList.add('is-active');
        scroll.stop();
    });

    close?.addEventListener('click', () => {
        overlay?.classList.remove('is-active');
        scroll.start();
    });

    overlay?.addEventListener('click', event => {
        if(!img?.contains(event.target)){
            overlay?.classList.remove('is-active');
            scroll.start();
        }
    });
}
export default handleStatementOverlay;